import { useTranslation } from 'react-i18next';
import type {
  CargoProblemDetail,
  CargoProblemMaterial,
  CargoProblemWorkspaceCapabilities,
} from '@magimp/shared';
import { Button, SectionCard } from '../../../ui/index.js';
import { CargoProblemAttachmentTiles } from './CargoProblemAttachments.js';

export function CargoProblemWorkCard({
  problem,
  capabilities,
  briefFiles,
  deleting,
  onDelete,
}: {
  problem: CargoProblemDetail;
  capabilities: CargoProblemWorkspaceCapabilities;
  /** Files filed with the problem itself; the work card is the only surface that holds them. */
  briefFiles: readonly CargoProblemMaterial[];
  deleting: boolean;
  onDelete: () => void;
}) {
  const { t } = useTranslation('cargoProblems');
  return (
    <SectionCard
      title={t('detail.workCard')}
      action={
        capabilities.canDelete ? (
          <Button size="sm" kind="danger" icon="trash-2" disabled={deleting} onClick={onDelete}>
            {t('actions.delete')}
          </Button>
        ) : undefined
      }
    >
      <div className="cargo-problem-work-card">
        <div>
          <span>{t('detail.description')}</span>
          <p className="cargo-problem-description">{problem.description}</p>
        </div>
        {briefFiles.length > 0 ? (
          <div>
            <span>{t('detail.briefMaterials')}</span>
            <CargoProblemAttachmentTiles problemId={problem.id} files={briefFiles} />
          </div>
        ) : null}
      </div>
    </SectionCard>
  );
}
